import { render, staticRenderFns } from "./pwdChange.vue?vue&type=template&id=2b33ae09&scoped=true"
import script from "./pwdChange.vue?vue&type=script&lang=js"
export * from "./pwdChange.vue?vue&type=script&lang=js"
import style0 from "./pwdChange.vue?vue&type=style&index=0&id=2b33ae09&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33ae09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b33ae09')) {
      api.createRecord('2b33ae09', component.options)
    } else {
      api.reload('2b33ae09', component.options)
    }
    module.hot.accept("./pwdChange.vue?vue&type=template&id=2b33ae09&scoped=true", function () {
      api.rerender('2b33ae09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/userInfo/pwdChange.vue"
export default component.exports